

import state from './moduleBannerState.js'
import mutations from './moduleBannerMutations.js'
import actions from './moduleBannerActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
